// Actions + sizing intents. ENGINE_DESIGN.md §1 (schema/action.ts).
import { z } from 'zod';
export const ActionKindSchema = z.enum(['fold', 'check', 'call', 'bet', 'raise', 'jam']);
export const SizingIntentSchema = z.enum([
    'min',
    'third',
    'half',
    'twoThirds',
    'threeQuarters',
    'pot',
    'overbet',
    'jam',
]);
/** Pot-fraction each intent means; single source of truth for bet-math grading (§7.3).
 *  'min' and 'jam' are context-computed (min-raise / all-in), not a fixed fraction. */
export const SIZING_FRACTION = {
    third: 1 / 3,
    half: 0.5,
    twoThirds: 2 / 3,
    threeQuarters: 0.75,
    pot: 1.0,
    overbet: 1.4,
};
export const ActionSchema = z.object({
    seat: z.number().int().nonnegative(),
    kind: ActionKindSchema,
    /** chips; for bet/raise this is the TO amount (raise-to). Absent for fold/check. */
    amount: z.number().nonnegative().optional(),
    /** hero only: the sizing intent chosen BEFORE typing the amount (bet-math UX). */
    sizingIntent: SizingIntentSchema.optional(),
});
//# sourceMappingURL=action.js.map